import { useState } from "react";
import { toast } from "sonner";
import { formatApiError, runAiJob } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { Textarea } from "../ui/textarea";
import { Button } from "../ui/button";
import { Sparkle, ListChecks } from "@phosphor-icons/react";

// Free-text team direction for ClaroLens + AI assist (refine wording; optionally pick matching requirements).
export const FocusInstructions = ({ value, onChange, standardIds, functions, term, onPicks }) => {
  const { aiEnabled } = useAuth();
  const [busy, setBusy] = useState("");
  const body = () => ({ instructions: value || "", standard_ids: standardIds, functions: functions || [], term: term || "" });
  const guard = () => {
    if (!(value || "").trim()) { toast.error("Write some focus instructions first"); return false; }
    if (!standardIds.length) { toast.error("Pick at least one standard first"); return false; }
    return true;
  };
  const refine = async () => {
    if (!guard()) return;
    setBusy("refine");
    try {
      const data = await runAiJob("/lens/focus-refine", body());
      onChange(data.instructions);
      toast.success("Direction refined — review and edit as needed");
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(""); }
  };
  const pick = async () => {
    if (!guard()) return;
    setBusy("pick");
    try {
      const data = await runAiJob("/lens/focus-pick", body());
      onPicks(data.picks || []);
      toast.success(`AI ticked ${(data.picks || []).length} matching requirement(s)`);
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(""); }
  };
  const aiTitle = !aiEnabled ? "AI features are turned off" : "Uses 1 AI credit";
  return (
    <div className="space-y-1.5" data-testid="lens-focus-instructions">
      <div className="text-[10px] text-muted-foreground">Focus instructions (guides the AI questions; stays within the selected standards):</div>
      <Textarea data-testid="lens-focus-instructions-input" value={value || ""} onChange={(e) => onChange(e.target.value)} rows={3} maxLength={2000}
        placeholder="e.g. Concentrate on how real-time operators confirm three-part communication during emergencies; skip training records."
        className="rounded-none text-xs" />
      <div className="flex gap-1.5">
        {onPicks && (
          <Button data-testid="lens-focus-pick-btn" type="button" variant="outline" size="sm" onClick={pick} disabled={!!busy || !aiEnabled}
            title={aiTitle} className="rounded-none h-7 text-[11px] flex-1">
            <ListChecks size={13} className="mr-1" />{busy === "pick" ? "Picking…" : "AI: pick requirements"}
          </Button>
        )}
        <Button data-testid="lens-focus-refine-btn" type="button" variant="outline" size="sm" onClick={refine} disabled={!!busy || !aiEnabled}
          title={aiTitle} className="rounded-none h-7 text-[11px] flex-1">
          <Sparkle size={13} weight="fill" className="mr-1" />{busy === "refine" ? "Refining…" : "Refine with AI"}
        </Button>
      </div>
    </div>
  );
};
